const formatPrice = (price) => {
  return price?.replace(/\.00|-/g, '');
};

export default formatPrice;
